import { Button } from '@/components/v2/Button'
import { cn } from '@/utils/style'
import { EyeIcon } from 'lucide-react'
import * as React from 'react'

type ViewOtherProps = {
  className?: string
}

export default function ViewOther(props: ViewOtherProps) {
  return null

  return (
    <Button
      className={cn('gap-2 items-center flex', props.className)}
      variant={'outline'}
    >
      <EyeIcon className="w-4 h-4" />
      <span>Visualizar outro diploma</span>
    </Button>
  )
}
